export default __webpack_public_path__ + "static/media/OpenSans-SemiboldItalic.1059fe1f.woff";